import { MobileMenuBar } from 'helpers/mobile-menu-bar';
import WebPushNotificationSubscribeHandler from './web-push-notification-subscribe-handler';

export class HeaderSearchMobile {

    private mobileHeaderSearchCollapse !: JQuery;

    public constructor() {
        this.init();
    }

    private init() : void {
        this.initMobileHeaderSearch();

        WebPushNotificationSubscribeHandler().init();
    }

    private getMobileHeaderSearchCollapse() : JQuery {
        if (typeof this.mobileHeaderSearchCollapse === 'undefined') {
            this.mobileHeaderSearchCollapse = $('#header-search-collapse');
        }

        return this.mobileHeaderSearchCollapse;
    }

    private initMobileHeaderSearch() : void {
        this.getMobileHeaderSearchCollapse().find('.search-collapse-link').on('click.mobileSearchCollapse', (event : JQuery.TriggeredEvent) => {
            event.preventDefault();
            this.getMobileHeaderSearchCollapse().collapse('hide');
        });

        this.getMobileHeaderSearchCollapse().on('click.mobileSearchCollapse show.bs.collapse', (event : JQuery.TriggeredEvent) => {
            if (event.type === 'click') {
                this.handleMobileCollapseClick(event);
            }
            else if (event.type === 'show') {
                MobileMenuBar.toggleMobileMenu('hide');
            }
        });

    }

    private handleMobileCollapseClick(event : JQuery.TriggeredEvent) : void {
        if ($(event.target).parent().is('body')) {
            this.getMobileHeaderSearchCollapse().collapse('hide');
        }
    }

}
